import { registerPresets } from '../loadingDecorator';
import { idPreset } from './idPreset';

registerPresets([{ name: 'id', preset: idPreset }]);
